const count = (value) => Number.isSafeInteger(value) && value >= 0;
const id = (value) => Number.isSafeInteger(value) && value > 0;

// Import and BPM jobs share states, but their running/terminal fields differ.
export function validateJob(data, kind = "import") {
  let valid = false;
  switch (data?.status) {
    case "none":
    case "stopping":
      valid = true;
      break;
    case "started":
      valid = id(data.job_id);
      break;
    case "running":
      valid =
        count(data.progress) &&
        count(data.import_total) &&
        (kind === "import"
          ? id(data.job_id) && (data.last_album === null || id(data.last_album))
          : count(data.items_updated) &&
            (data.last_track === null || id(data.last_track)));
      break;
    case "completed":
    case "failed":
    case "stopped":
      valid =
        id(data.job_id) &&
        (kind === "track" || count(data.import_total)) &&
        (kind === "import"
          ? data.acknowledged_at === null ||
            (typeof data.acknowledged_at === "string" &&
              Number.isFinite(Date.parse(data.acknowledged_at)))
          : count(data.items_updated));
      break;
    default:
      break;
  }
  if (!valid)
    throw new Error(
      "Invalid background job response. Refresh the status before retrying.",
    );
  return data;
}
